import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// Keep the entire website out of search engines everywhere —
// both the standalone URL and when embedded (iframe) on comunitatearise.ro.
const ROBOTS_CONTENT = "noindex, nofollow, noarchive, nosnippet, noimageindex";
["robots", "googlebot"].forEach(name => {
  let meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = ROBOTS_CONTENT;
});
render(<App data-id="element-334" data-mp="2k05nl8y5cr1i" />, document.getElementById("root"));